module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_8.45272d82.mp3";